import i18next from 'i18next';
/**
 * Always shows the info notice explaining what changing capture settings does -- purely
 * informational, not a confirmation gate, so it never blocks Save.
 */
export const useShowCaptureConsequencesNotice = () => i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.settings.consequencesNotice);
